import { useState } from 'react'
import './style.scss'
import { Trans, useTranslation } from 'react-i18next'

export default function Captcha({ data, submit }) {
	const [value, setValue] = useState([])
	const { t } = useTranslation()

	const toggleSelect = (i) => {
		setValue((prev) => {
			if (prev.includes(i)) {
				return prev.filter((item) => item !== i)
			} else {
				return [...prev, i]
			}
		})
	}

	const setCount = (i) => {
		setValue([parseInt(i)])
	}

	return (
		<div className='captcha'>
			<div className='boxText'>
				<div className='boxText_header'>{t('captcha.title')}</div>
				<div className='boxText_body'>
					{data.type === 'select' || data.type === 'select_one' ?
						<div className='captcha__wrap'>
							<div className={'captcha__title' + (data.type === 'select_one' ? ' captcha__title--flex' : '')}>
								<Trans
									i18nKey='captcha.select'
									values={{
										value: data.type === 'select_one' ? '' : t(`captcha.categories.${data.target_code}`, { defaultValue: data.target_code })
									}}
									components={{
										emoji:
										data.type === 'select_one' ? (
											<span style={{ backgroundImage: `url(${data.target_code})` }} />
										) : (
											<b />
										),
									}}
								/>
							</div>
							<div className='captcha__buttons'>
								{data.emojis.map((emoji, i) =>
									<button key={i} className={'captcha__buttons-btn' + (value.includes(i) ? ' captcha__buttons-btn--active' : '')} type='button' onClick={() => toggleSelect(i)}>
										<span style={{backgroundImage: `url(${emoji})`}}></span>
									</button>
								)}
							</div>
							<div className='captcha__send'>
								<button className='btn' onClick={() => submit(value)}>{t('captcha.send')}</button>
							</div>
						</div>
					:
						<div className='captcha__wrap'>
							<div className={'captcha__title' + (data.type === 'count_one' ? ' captcha__title--flex' : '')}>
								<Trans
									i18nKey='captcha.count'
									values={{
										value: data.type === 'count_one' ? '' : t(`captcha.categories.${data.target_code}`, { defaultValue: data.target_code })
									}}
									components={{
										emoji:
										data.type === 'count_one' ? (
											<span style={{ backgroundImage: `url(${data.target_code})` }} />
										) : (
											<b />
										),
									}}
								/>
							</div>
							<div className='captcha__emojis'>
								{data.emojis.map((emoji, i) =>
									<span key={i} className='captcha__emojis-item' style={{backgroundImage: `url(${emoji})`}}></span>
								)}
							</div>
							<div className='captcha__input'>
								<input type='number' inputMode='numeric' className='input' onInput={(e) => setCount(e.target.value)} />
							</div>
							<div className='captcha__send'>
								<button className='btn' onClick={() => submit(value)}>{t('captcha.send')}</button>
							</div>
						</div>
					}
				</div>
			</div>
		</div>
	)
}
